import { Route } from '@angular/router';
import { Permission } from '../../models/permission.model';
import { PermissionGuard } from '../../shared/guards/permission.guard';

export const accountOnboardingRoute: Route = {
  path: 'account-onboarding',
  children: [
    {
      // Return URL from the external signing provider: only AuthGuard (parent) must run.
      path: ':id/sign-successful',
      loadComponent: () =>
        import('./sign-successful/sign-successful.component').then(
          (c) => c.AccountOnboardingSignSuccessfulComponent,
        ),
    },
    {
      path: '',
      canActivate: [PermissionGuard],
      data: {
        permissions: [
          Permission.PORTFOLIO_ASSISTANT,
          Permission.PORTFOLIO_MANAGER,
          Permission.CLIENT,
        ],
      },
      children: [
        {
          path: ':id',
          loadComponent: () =>
            import('./account-onboarding.component').then((c) => c.AccountOnboardingComponent),
        },
      ],
    },
  ],
};

export const managerAccountOnboardingRoute: Route = {
  path: 'manager/account-onboarding',
  canActivate: [PermissionGuard],
  data: { permissions: [Permission.PORTFOLIO_ASSISTANT, Permission.PORTFOLIO_MANAGER] },
  children: [
    {
      path: ':id',
      loadComponent: () =>
        import('./account-onboarding.component').then((c) => c.AccountOnboardingComponent),
    },
    {
      path: 'view/:id',
      loadComponent: () =>
        import('./account-onboarding.component').then((c) => c.AccountOnboardingComponent),
    },
  ],
};
